import { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import { useFetchBikajiLedgerMutation, useFetchUserOrderMutation, useUpdateUserOrderMutation, } from "../../../features/tenant/Bikaji/BikajiApi";
import toast from "react-hot-toast";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import dayjs from "dayjs";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";

const BikajiOrderLedger = () => {
  const navigate = useNavigate();
  const [tableDataItems, setTableDataItems] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userOrders, setUserOrders] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const initialRequest = {
    month: dayjs().subtract("1", "month").format("M"),
    year: dayjs().format("YYYY"),
  };
  const [request, setRequest] = useState(initialRequest);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectAll = (checked) => {
    if (checked) {
      // Select only rows where sync_done === false
      const ids = tableDataItems.filter((row) => !row.sync_done).map((row) => row.buyer_app_user_id);
      setSelectedRows(ids);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id, checked) => {
    setSelectedRows((prev) =>
      checked ? [...prev, id] : prev.filter((rowId) => rowId !== id)
    );
  };

  const clearFilters = () => {
    setRequest(initialRequest);
    handleBikajiOrdersList(initialRequest)
  };

  const [
    fetchAllBikajiOrders,
    {
      data: fetchAllBikajiOrdersData,
      error: fetchAllBikajiOrdersError,
      isLoading: fetchAllBikajiOrdersisLoading,
    },
  ] = useFetchBikajiLedgerMutation();

  const [
    updateUserOrder,
    {
      data: updateUserOrderData,
      error: updateUserOrderError,
      isLoading: updateUserOrderisLoading,
    },
  ] = useUpdateUserOrderMutation();

  const handleBikajiOrdersList = (orderRequest = request) => {
    fetchAllBikajiOrders({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      month: orderRequest.month,
      year: orderRequest.year
    });
  };

  const [fetchUserOrders, { data: userOrdersData, isLoading: isLoadingUserOrders }] =
    useFetchUserOrderMutation();


  useEffect(() => {

    handleBikajiOrdersList();

  }, []);

  useEffect(() => {
    if (
      fetchAllBikajiOrdersData &&
      fetchAllBikajiOrdersData.body
    ) {
      toast.dismiss();
      toast.success(`${fetchAllBikajiOrdersData.message}`, {
        id: "fetchAllBikajiOrdersData",
      });
      console.log(
        "transactionsData  data",
        fetchAllBikajiOrdersData
      );
      const arr = [...fetchAllBikajiOrdersData.body.orders ?? []];
      setTableDataItems(arr);


    }

    if (fetchAllBikajiOrdersError) {
      console.log(
        "transactionsData error",
        fetchAllBikajiOrdersError
      );
      toast.dismiss();
      toast.error(`${fetchAllBikajiOrdersError.data.message}`, {
        id: "fetchAllBikajiOrdersError",
      });
    }
  }, [
    fetchAllBikajiOrdersData,
    fetchAllBikajiOrdersError,
  ]);

  useEffect(() => {
    if (
      updateUserOrderData &&
      updateUserOrderData.body
    ) {
      toast.dismiss();
      toast.success(`Earnings Updated`, {
        id: "fetchAllBikajiOrdersData",
      });
      setSelectedRows([])
      handleBikajiOrdersList()
    }

    if (updateUserOrderError) {
      console.log(
        "Something Went Wrong ",
        fetchAllBikajiOrdersError
      );
      toast.dismiss();
      toast.error(`${updateUserOrderError.data.message}`, {
        id: "fetchAllBikajiOrdersError",
      });
    }
  }, [
    updateUserOrderData,
    updateUserOrderError,
  ]);

  const handleViewOrders = (userId) => {
    setSelectedUser(userId);
    setIsModalOpen(true);

    fetchUserOrders({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      user_id: userId,
      start_date: dayjs(`${request.year}-${request.month}-01`).format("YYYY-MM-DD"),
      end_date: dayjs(`${request.year}-${request.month}-01`).endOf("month").format("YYYY-MM-DD")
    });
  };

  useEffect(() => {
    if (userOrdersData?.body?.orders) {
      setUserOrders(userOrdersData.body.orders);
    }
  }, [userOrdersData]);

  const updateOrders = () => {
    console.log(selectedRows)
    if (selectedRows.length === 0) {
      toast.error("Please select orders")
    }
    updateUserOrder({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: {
        userIds: selectedRows.map(el => String(el)),
        month: request.month,
        year: request.year
      }
    })
  }


  const columns = [
    {
      name: (
        <input
          type="checkbox"
          checked={
            tableDataItems.filter((row) => !row.sync_done).length > 0 &&
            selectedRows.length === tableDataItems.filter((row) => !row.sync_done).length
          }
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          disabled={row.sync_done} // disable if sync_done === true
          checked={selectedRows.includes(row.buyer_app_user_id)}
          onChange={(e) => handleRowSelect(row.buyer_app_user_id, e.target.checked)}
        />
      ),
      width: "60px",
    },
    {
      name: "S.No",
      cell: (row, idx) => idx + 1,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Mobile",
      selector: (row) => row.mobile,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      width: "200px",
    },
    {
      name: "User Id",
      selector: (row) => row.user_id,
    },
    {
      name: "Membership",
      selector: (row) => row.current_tier_name,
    },
    {
      name: "Points",
      selector: (row) => row.points ?? 0,
    },
    {
      name: "Total Orders",
      selector: (row) => row.total_orders ?? 0,
    },
    {
      name: "Total Amount",
      selector: (row) => row.total_amount ?? 0,
    },
    {
      name: "Sync Done",
      selector: (row) => (row.sync_done ? "Yes" : "No"),
    },
    {
      name: "",
      cell: (row) => (
        <div>
          <button
            onClick={(e) => handleViewOrders(row.buyer_app_user_id)}
            className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-lg transition duration-150 ease-in-out hover:bg-danger-600 focus:bg-danger-600 active:bg-danger-700"
          >
            View Order
          </button>
        </div>
      ),
      width: "250px",
    }
  ];

  const orderColumns = [
    {
      name: "S.No",
      cell: (row, idx) => idx + 1,
      width: "80px",
    },
    {
      name: "Order No",
      selector: (row) => row.order_no,
    },
    {
      name: "Date",
      selector: (row) => row.voucher_date,
    },
    {
      name: "Amount",
      selector: (row) => row.purchase_amount,
      width: "200px",
    },
    {
      name: "Points",
      selector: (row) => row.points,
    }
  ];

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Order Requests List
            <LinksComponent />
          </div>

          <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
            <div className="flex justify-between items-start">


            </div>
            <div className="flex  space-x-2 ">
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Month
                  </label>
                  <input
                    type="month"
                    id="month-picker"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    placeholder="Select Month"
                    max={dayjs().format("YYYY-MM")}
                    value={`${request.year || ""}-${request.month?.toString().padStart(2, "0") || ""}`}
                    onChange={(e) => {
                      const [year, month] = e.target.value.split("-");
                      setRequest((prev) => ({
                        ...prev,
                        year,
                        month: Number(month),
                      }));
                    }}
                  />

                </div>
              </div>
              <div className="">
                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                  &nbsp;
                </label>

                <div className="flex flex-row  gap-2 ">
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        handleBikajiOrdersList();

                      }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        updateOrders();

                      }}
                    >
                      Update Order
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3">
            {fetchAllBikajiOrdersisLoading && <CircleLoaderComponent />}
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={tableDataItems}
                pagination={false}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <ModalComponent
          size={null}
          show={isModalOpen}
          setShow={() => {
            setIsModalOpen(false)
            setSelectedUser(null)
            setUserOrders([])
          }}
          className="max-w-4xl max-h-[50%]"
        >
          <div className="w-full h-full p-3 space-y-6 overflow-y-auto">
            <h2 className="text-lg font-bold">
              Orders
            </h2>
            <DataTableComponent
              keyField={(row) => row.SNo}
              columns={orderColumns}
              data={userOrders}
              pagination={false}
            ></DataTableComponent>
          </div>
        </ModalComponent>
      )}


    </>
  );
};

export default BikajiOrderLedger;
